import SearchBox from 'components/common/SearchBox';
import {
  HVACampaignsTable,
  hvacampaignsTablecolumns
} from 'components/tables/HVACampaignsDashboardTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useEffect, useState, KeyboardEvent } from 'react';
import {
  fetchHVAUserCampaigns,
  HVACampaign
} from 'services/hvaservicecampaign.service';

const CampaignList = () => {
  const [hvacampaigns, setHVACampaigns] = useState<HVACampaign[]>([]);

  useEffect(() => {
    const getHVACampaigns = async () => {
      try {
        const hvacampaignsData = await fetchHVAUserCampaigns();
        setHVACampaigns(hvacampaignsData);
      } catch (error) {
        console.error('Error fetching campaigns:', error);
      }
    };

    getHVACampaigns();
  }, []);

  const table = useAdvanceTable({
    data: hvacampaigns,
    columns: hvacampaignsTablecolumns,
    pageSize: 5,
    pagination: true,
    sortable: true,
    selection: false
  });

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const handleSearchKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  return (
    <div>
      <div className="mb-9">
        <AdvanceTableProvider {...table}>
          <div className="mb-4">
            <div className="d-flex flex-wrap gap-3">
              <SearchBox
                placeholder="Search Services and Campaigns"
                onChange={handleSearchInputChange}
                onKeyDown={handleSearchKeyPress}
              />
            </div>
          </div>

          <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-translucent position-relative top-1">
            <HVACampaignsTable />
          </div>
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default CampaignList;
